@if (initialized) {
    <div class="grid">
        <!-- Analysis Results List -->
        <div class="col-12 lg:col-4">
            <div class="card">
                <mvs-widget
                        *ngIf="analysisResultsWidget"
                        [widgetData]="analysisResultsWidget"
                        (onObjectSelect)="handleAnalysisSelect($event)"
                ></mvs-widget>
            </div>
        </div>

        @if (selectedAnalysisResult) {
            <!-- Quality Score -->
            <div class="col-12 lg:col-8">
                <div class="card">
                    <div class="grid">
                        <div class="col-12 lg:col-4">
                            <h5 class="mb-3">Quality Score</h5>
                            <ea-quality-score-widget
                                    [analysisResultId]="selectedAnalysisResult.id"
                            ></ea-quality-score-widget>
                        </div>
                        <div class="col-12 lg:col-8">
                            <h5 class="mb-3">Analysis Summary</h5>
                            <div class="grid">
                                <div class="col-4">
                                    <div class="surface-100 p-3 border-round text-center">
                                        <div class="text-2xl font-bold text-primary">{{ selectedAnalysisResult.columnCount }}</div>
                                        <div class="text-sm text-600">Columns</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="surface-100 p-3 border-round text-center">
                                        <div class="text-2xl font-bold text-primary">{{ selectedAnalysisResult.analyzedRowCount }}</div>
                                        <div class="text-sm text-600">Rows Analyzed</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="surface-100 p-3 border-round text-center">
                                        <div class="text-2xl font-bold text-primary">{{ selectedAnalysisResult.duplicatePercentage | number:'1.1-1' }}%</div>
                                        <div class="text-sm text-600">Duplicates</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Column Analysis -->
            <div class="col-12 lg:col-8">
                <div class="card">
                    <h5 class="mb-3">Column Analysis</h5>
                    <ea-column-analysis-widget
                            [analysisResultId]="selectedAnalysisResult.id"
                            (onColumnSelect)="handleColumnSelect($event)"
                    ></ea-column-analysis-widget>
                </div>
            </div>

            <!-- Column Detail / Value List -->
            <div class="col-12 lg:col-4">
                @if (selectedColumn) {
                    <div class="card">
                        <h5 class="mb-3">Column Details: {{ selectedColumn.name }}</h5>
                        <ea-column-detail-widget
                                [columnId]="selectedColumn.id"
                        ></ea-column-detail-widget>
                    </div>

                    @if (selectedColumn.hasValueList) {
                        <div class="card mt-3">
                            <h5 class="mb-3">Value List</h5>
                            <ea-value-list-widget
                                    [columnId]="selectedColumn.id"
                            ></ea-value-list-widget>
                        </div>
                    }
                } @else {
                    <div class="card">
                        <div class="flex flex-column align-items-center justify-content-center p-6 text-center surface-100 border-round">
                            <i class="fa-regular fa-columns text-4xl text-400 mb-3"></i>
                            <span class="text-600">Select a column to view details</span>
                        </div>
                    </div>
                }
            </div>
        } @else {
            <div class="col-12 lg:col-8">
                <div class="card">
                    <div class="flex flex-column align-items-center justify-content-center p-6 text-center surface-100 border-round">
                        <i class="fa-regular fa-chart-bar text-4xl text-400 mb-3"></i>
                        <span class="text-600">Select an analysis result to view details</span>
                    </div>
                </div>
            </div>
        }
    </div>
}
